import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/home/Home.vue";
import Company from "../views/company/Company";
import Job from "../views/job/Job";
import Search from "../views/search/Search";
import WellCompany from "../views/wellknown/WellCompany";
import ErrorPage from "../views/error/Error";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    meta: {
      title: '锐仕校园-您身边的校招专家',
      keywords: '',
      description: '',
    }
  },
  {
    path: "/company",
    name: "company",
    component: Company,
    meta: {
      title: '锐仕校园-公司详情'
    }
  },
  {
    path: "/job",
    name: "job",
    component: Job,
    meta: {
      title: '锐仕校园-职位详情',
    }
  },
  {
    path: "/search",
    name: "search",
    component: Search,
    meta: {
      title: '锐仕校园-搜索',
    }
  },
  {
    path: "/wellcompany",
    name: "wellcompany",
    component: WellCompany,
    meta: {
      title: '锐仕校园-名企招聘',
    }
  },
  {
    path: '*',
    component: ErrorPage
  }
];

const router = new VueRouter({
  mode: "history",
  // linkActiveClass: 'active',
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  },
  routes,
});

export default router;
